/**
 * @author omriha
 * 01/10/2019
 */
import React from "react";
import {connect, useDispatch} from "react-redux";
import {push} from "connected-react-router";
import {useTranslation} from "react-i18next";
import queryString from "query-string";
import SMCPage from "../../../components/core/pageComponents/SMCPage";
import ButtonContainer from "../../../components/Simple/ButtonContainer";
import {useBoolean, useEditorDimensions} from "../../../utils/hooks";
import LabelContainer from "../../../components/Page/LabelContainer";
import SMCEditor from "../../../components/Editor";
import {SMCPaths} from "../../../conf/Routes";
import SMCButton from "../../../components/Simple/SMCButton";
import {usePlanEditor} from "./PlanEditorHelper";
import {planPermissionsSelector} from "../../../store/selectors/user.selectors";
import {SMCDisabledProvider} from "../../../components/Simple/SMCDisabledContext";
import RouteLeavingGuard from "../../PopupPages/RouteLeavingGuard";
import PlanCloneModal from "../../PopupPages/PlanCloneModal";
import {PlanGetSchema} from "../../../api/DBSchema/Plan";
import {setShowBackButton} from "../../../store/actions/view.actions";
import VerifyButtonsContainer from "../VerifyButtonsContainer";
import ButtonsContainerStyles from '../ButtonsContainerStyles'
import lineSeparator from "../../../assets/images/Line.png";

/**
 * High level element to fetch, edit and save plan, all logic implemented inside.
 * @param {string} id Id of plan to fetch from the server to edit
 */
function PlanEditor({ navigateTo, id, urlParams, planPermissions }) {


    const { t } = useTranslation();
    const { editorWidth, editorHeight } = useEditorDimensions();const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(setShowBackButton(true, t("SMC_PLANE_EDITOR_PAGENAME")));
    return () => {
      dispatch(setShowBackButton(false, ""));
    };
  }, [dispatch, t]);

    const modifyPermission = planPermissions ? planPermissions.modify : true;
    const deletePermission = planPermissions ? planPermissions.delete : true;
    const createPermission = planPermissions ? planPermissions.create : true;

  let defaultPage = "general";
    const queryParams = queryString.parse(urlParams);
  if (queryParams && queryParams["page"]) {
    defaultPage = queryParams["page"];
    }

  const [isPlanCloneModalOpen, openPlanCloneModal, closePlanCloneModal] =
    useBoolean(false);
    const classes = ButtonsContainerStyles();

    const {
        planObject,
        origPlanObject,
        isObjectDirty,
        editorPages,
        helpId,
        availableFirmwares,
        isSMEReportEnabled,
        isReportConfirmationEnabled,
        isHasEditPermissionForReportsConfig,
        isPageDataLoaded,
        isPageLoadFailed,
        isInnerPageLoading,
        chosenPageId,
        errorMessagesByPageList,
        onPageChange,
        setPlanData,
        saveButtonOnClick,
        revertButtonOnClick,
        reloadPageData,
        deleteButtonOnClick,
        appiData,
        uoTableData,
        zonesData,
        setUoTableDataValue,
        setAppiDataValue,
    } = usePlanEditor(id, defaultPage);

    // Data passed down to the editor pages
    const editorPageData = {
        planObject,
        origPlanObject,
        availableFirmwares,
        isSMEReportEnabled,
        isReportConfirmationEnabled,
        isHasEditPermissionForReportsConfig,
        setEditorPageId: onPageChange,
        setPlanData,
        isPageDataLoaded,
        appiData,
        uoTableData,
        zonesData,
        setUoTableDataValue,
        setAppiDataValue
    }

    const name = planObject?.[PlanGetSchema.id];

    return (
        <>
        <RouteLeavingGuard when={isObjectDirty} />
        <SMCPage loading={!isPageDataLoaded} helpId={helpId}>
            <div className="ObjectEditor" style={{ width: editorWidth }}>
                    <ButtonContainer className={classes.headerContainer}>
                        <LabelContainer value={id}/>
                        <div>
                            <div style={{display: 'flex'}}>
                    <ButtonContainer>
                                    <SMCButton
                                        labelClassName={classes.labelColor}
                                        icon="delete"
                                        variant="ghost"
                                        disabled={!isPageDataLoaded || !deletePermission}
                                        onClick={deleteButtonOnClick}>
                                        {t('SMP_DELETE_PLAN')}
                                    </SMCButton>
                                    <img src={lineSeparator} className={classes.separator} alt="separator"/>
                                    <SMCButton
                                        labelClassName={classes.labelColor}
                                        icon="clone"
                                        variant="ghost"
                                        disabled={!isPageDataLoaded || !createPermission}
                                        onClick={openPlanCloneModal}>
                                        {t('ACTION_CLONE')}
                                    </SMCButton>
                    </ButtonContainer>
                </div>
                        </div>
                    </ButtonContainer>
                <SMCDisabledProvider forceDisable={!modifyPermission}>
                    <SMCEditor
                        editorPageData={editorPageData}
                        height={editorHeight}
                        width={editorWidth}
                        errorListByPage={errorMessagesByPageList}
                        chosenPageId={chosenPageId}
                        onPageChange={onPageChange}
                        isPageLoaded={isPageDataLoaded && !isInnerPageLoading}
                        isPageLoadFailed={isPageLoadFailed}
                        reloadData={reloadPageData}
                        pages={editorPages}
                    />
                </SMCDisabledProvider>
            </div>
            <PlanCloneModal
                isOpen={isPlanCloneModalOpen}
                onRequestClose={closePlanCloneModal}
                originalObject={planObject}
                originalName={name}
                onSuccess={name => navigateTo(SMCPaths.plans+'?id='+name)}
            />
        </SMCPage>
            <VerifyButtonsContainer
                disabled={!isPageDataLoaded || !modifyPermission}
                onClickSaveButton={saveButtonOnClick}
                onClickCancelButton={revertButtonOnClick}
            />
        </>
    );
}

const mapStateToProps = (state) => ({
    planPermissions: planPermissionsSelector(state),
    urlParams: state.router.location.search
});

const mapDispatchToProps = {
    navigateTo: push
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanEditor);

